import React from "react";
import styled from "styled-components";
import { Heading } from "@/components/UtilityComponents/Heading";
import HTMLRender from "@/shared/globals/UiElements/HTMLRender";
import { Section } from "@/shared/layout";
import { HomeContentSectionProps } from "../../types";
import { useLocale } from "@/i18n/i18n-client";
import ClientComponent from "@/shared/globals/UiElements/ClientComponent";

const HomeContentSection: React.FC<HomeContentSectionProps> = ({ section }) => {
  const { code: activeLocale } = useLocale();

  const translations = section?.translations?.find(
    (translation) => translation.locale === activeLocale
  );

  const header = translations?.header || section?.header;
  const content = translations?.content || section?.content;

  return (
    <StyledSection stretchToFullWidth={section?.stretchToFullWidth}>
      {section?.showSectionHeader && <Heading>{header}</Heading>}
      <ClientComponent>
        <ContentHtml html={content} />
      </ClientComponent>
    </StyledSection>
  );
};

export default HomeContentSection;

const ContentHtml = styled(HTMLRender)`
  ul {
    list-style-position: inside;
    list-style-type: disc;
  }
  ol {
    list-style-position: inside;
    list-style-type: decimal;
  }
`;

const StyledSection = styled(Section)<{ stretchToFullWidth?: boolean }>`
  && {
    max-width: ${({ stretchToFullWidth }) => stretchToFullWidth && "100vw"};
    padding: ${({ stretchToFullWidth }) => stretchToFullWidth && "unset"};
  }
`;
